import { faPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip';
import { QBox, QChip, QIcon, QText } from '@captivateiq/quotient';

import { useAIShellContext } from '@captivateiq/assistant/AIShellContext';
import type { Message, MessageButtonSpec } from '@captivateiq/assistant/types';

import { MessageButtonBar } from './MessageButtonBar';
import { FileNameLabel } from '../shared/FileNameLabel';
import { expandedTextColumnSx } from '../../shared/expandedTextColumnSx';

type UserMessageProps = {
  message: Message;
  buttons?: MessageButtonSpec[];
};
export const UserMessage = ({ message, buttons = [] }: UserMessageProps) => {
  const { isExpanded } = useAIShellContext();
  return (
    <>
      {buttons?.length > 0 && <MessageButtonBar align="right" buttons={buttons} />}
      <QBox
        data-testid="user-message"
        sx={{
          alignItems: 'center',
          backgroundColor: 'primary.200',
          border: '1px solid',
          borderColor: 'primary.300',
          borderRadius: '8px',
          justifyContent: 'stretch',
          padding: '12px',
          ...expandedTextColumnSx(isExpanded),
        }}
      >
        {message.attachments && message.attachments.length > 0 && (
          <QBox sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
            {message.attachments.map((att) => (
              <QChip
                icon={<QIcon icon={faPaperclip} sx={{ fontSize: '12px' }} />}
                key={att.uuid}
                label={<FileNameLabel fileName={att.fileName} />}
                size="small"
                sx={{ maxWidth: '100%', '& .MuiChip-label': { display: 'flex', overflow: 'hidden' } }}
              />
            ))}
          </QBox>
        )}
        <QText
          sx={{
            color: 'primary.900',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
            overflowWrap: 'break-word',
          }}
        >
          {message.contents}
        </QText>
      </QBox>
    </>
  );
};
